// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:47:05

export default {
  "id": "1945-air-force-airplane",
  "slug": "1945-air-force-airplane",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/17350d22da6b4bc7ba9685b0eb4edbaa-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/17350d22da6b4bc7ba9685b0eb4edbaa/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "1945 Air Force Airplane",
      "description": "Welcome to the 1945 Air Force: Airplane! Begin intense shooting battles in the sky as you engage in nervous fighting action. Upgrade your plane, defeat enemies, and enter epic aerial battles.Every victory brings you closer to becoming the ultimate air force commander.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "airplane",
        "battlefield",
        "enemies",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "1945年空军飞机",
      "description": "欢迎来到1945空军：飞机！开始在天空中进行激烈的射击战斗，体验紧张刺激的空战行动。升级你的飞机，击败敌人，进入史诗般的空战。每场胜利都让你更接近成为终极空军指挥官。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "飞机",
        "战场",
        "敌人",
        "射击类"
      ]
    },
    "zh-TW": {
      "title": "1945年空軍飛機",
      "description": "歡迎加入1945空軍：飛機！在天空展開激烈射擊戰鬥，參與緊張的戰鬥行動。升級你的飛機，擊敗敵人，進入傳說性的空戰。每一次勝利都將你帶近成為最終空軍司令官的目標。",
      "instructions": "滑鼠點擊或輕觸即可遊玩",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "飛機",
        "戰場",
        "敵人",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "1945年空軍飛機",
      "description": "歡迎加入1945空軍：飛機！開始在天空中進行激烈的射擊戰鬥，參與緊張的作戰行動。升級你的飛機，擊敗敵人，並進入經典的空中戰鬥。每一次勝利都將你帶得更接近成為最終空軍司令官。",
      "instructions": "用滑鼠點擊或觸碰以遊玩",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "飛機",
        "戰場",
        "敵人",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "1945年航空機",
      "description": "1945空軍：飛行機へようこそ！緊迫した空中銃撃戦に参加し、緊張感のある戦闘行動を始めましょう。飛行機をアップグレードし、敵を撃退し、壮大な空中戦に挑戦しましょう。どの勝利も、究極の空軍司令官への道を一歩近づかせます。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "飛行機",
        "戦場",
        "敵",
        "シューティングアップ"
      ]
    },
    "ko": {
      "title": "1945 공군 비행機",
      "description": "1945空军: 비행기에 오신 것을 환영합니다! 하늘에서 열정적인 총알전투에 참여하여 긴장된 전투 행동을 펼쳐보세요. 비행기를 업그레이드하고 적을 물리치고, 전설적인 공중전을 치르세요. 모든 승리는 최종 공군 사령관이 되는 데 더 가까워지게 합니다.",
      "instructions": "마우스 클릭 또는 탭하여 플레이",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "전투기",
        "전장",
        "敵인",
        "쏘아치기 게임"
      ]
    },
    "fr": {
      "title": "Avion de l'Armée de l'Air de 1945",
      "description": "Bienvenue dans l'Armée de l'Air 1945 : Avion ! Commencez des batailles de tir intenses dans le ciel tout en engageant des combats nerveux. Améliorez votre avion, battez vos ennemis et participez à des batailles aériennes épiques. Chaque victoire vous rapproche de devenir le commandant suprême de l'armée de l'air.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Facile",
        "tireur"
      ],
      "tags": [
        "avion",
        "champ de bataille",
        "ennemis",
        "shoot-'em-up"
      ]
    }
  }
};
